// src/services/dashboardPageService.ts
import api from './api';

export interface ContagemEmpreendimentoPorTipo {
  Lote: number;
  Apartamento: number;
  Comercial: number;
  Casa: number;
  Compacto: number;
}

export interface ContagemUnidadesPorQuarto {
  "1_quarto": number;
  "2_quartos": number;
  "3_quartos": number;
  "4_ou_mais_quartos": number;
}

export interface UnidadeCidade {
  disponivel_ou_distrato: number;
  vendidas: number;
  preco_m2_medio: number;
}

export interface VGVResponseItem {
  mes: string;
  unidades_vendidas: number;
  vgv: number;
  valor_medio: number;
}

export interface EvolucaoVendaResponseItem {
  mes: string;
  vendidas: number;
}

export interface EvolucaoDeVendasResponse {
  historico_vendas: EvolucaoVendaResponseItem[];
  media_vendas: number;
}

export type UnidadesPorCidadeResponse = Record<string, UnidadeCidade>;

// 👇 Mapeamento de inglês -> abreviação em português
const monthMap: Record<string, string> = {
  January: "Jan",
  February: "Fev",
  March: "Mar",
  April: "Abr",
  May: "Mai",
  June: "Jun",
  July: "Jul",
  August: "Ago",
  September: "Set",
  October: "Out",
  November: "Nov",
  December: "Dez",
};

function translateMonth(month: string): string {
  return monthMap[month] ?? month;
}

export const getContagemEmpreendimentoPorTipo = async (): Promise<ContagemEmpreendimentoPorTipo> => {
  const { data } = await api.get<ContagemEmpreendimentoPorTipo>('/contagem empreendimento por tipo/');
  return data;
};

export const getContagemUnidadesPorQuarto = async (): Promise<ContagemUnidadesPorQuarto> => {
  const { data } = await api.get<ContagemUnidadesPorQuarto>('/contagem unidades por quarto/');
  return data;
};

export async function getContagemUnidadesPorCidade(): Promise<UnidadesPorCidadeResponse> {
  const { data } = await api.get<UnidadesPorCidadeResponse>("/contagem unidades por cidade/");
  return data;
}

// 👇 já converte meses para português
export async function getVGVUltimos12Meses(): Promise<VGVResponseItem[]> {
  const { data } = await api.get<VGVResponseItem[]>("/vgv nos ultimos 12 meses/");
  return data.map(item => ({
    ...item,
    mes: translateMonth(item.mes),
  }));
}

// 👇 também já converte meses para português
export async function getEvolucaoDeVendas(): Promise<EvolucaoDeVendasResponse> {
  const { data } = await api.get<EvolucaoDeVendasResponse>("/evolucao de venda/");
  return {
    ...data,
    historico_vendas: data.historico_vendas.map(item => ({
      ...item,
      mes: translateMonth(item.mes),
    })),
  };
}
